import script from "./ExperienceDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ExperienceDetails.vue?vue&type=script&setup=true&lang=js"

import "./ExperienceDetails.vue?vue&type=style&index=0&id=77610643&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77610643"]])

export default __exports__